import { render, staticRenderFns } from "./ComputerItem.vue?vue&type=template&id=d6f79f6e&scoped=true"
import script from "./ComputerItem.vue?vue&type=script&lang=js"
export * from "./ComputerItem.vue?vue&type=script&lang=js"
import style0 from "./ComputerItem.vue?vue&type=style&index=0&id=d6f79f6e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6f79f6e",
  null
  
)

export default component.exports